import * as React from 'react';

import s from './Card.scss';

export const Empty = () => (
  <div className={s('card', 'empty')}>
    <div className={s.card__imageWrap} />

    <div className={s.card__content} />
  </div>
);
    
